<template lang="pug">
.plugins(v-if="plugins.length > 0")
  el-row
    el-col.plugin(v-for="plugin in plugins" :key="plugin.id")
      .inner
        template(v-if="plugin.enabled")
          a.enabled
            img(:class="plugin.plugin_type" :src="getPluginImage(plugin)")
            div
              p.contract-label
                span.title {{ $t('UserInfo.contracted') }}
        template(v-else)
          a.disabled(@click="showPluginDialog(plugin)")
            img(:class="plugin.plugin_type" :src="getPluginImage(plugin)")
            p.uncontract-label
              span {{ $t('UserInfo.uncontracted') }}

  el-dialog.plugin(:title="selectedPlugin.title" class="enabledPlugins" :visible.sync="isShowEnabledPluginDialog" width="600px")
    .plugin-image
      img(:src="selectedPlugin.image")
    p(v-html="selectedPlugin.description")
    p {{ $t('Plugin.confirm_adding', { plugin: selectedPlugin.name }) }}
    p.plugin-price
      span {{ $t('UserInfo.plugins.price_type') }}：
      span(v-html="selectedPlugin.price")
    span.dialog-footer(slot="footer")
      el-button(@click="isShowEnabledPluginDialog=false" :disabled="isLoading") {{$t('UserInfo.cancelButton')}}
      el-button(type="primary" @click="enablePlugin" :loading="isLoading" :disabled="isLoading") {{$t('UserInfo.contract')}}
</template>

<script>
import PluginApi from '@/api/plugin'
export default {
  props: {
    plugins: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      isLoading: false,
      isShowEnabledPluginDialog: false,
      selectedPlugin: {
        type: '',
        name: '',
        title: '',
        description: '',
        price: '',
        image: ''
      },
    }
  },
  methods: {
    // プラグイン選択時にプラグイン情報を設定する
    setSelectedPlugin(plugin) {
      const pluginType = plugin.plugin_type

      // pluginType（例: 'favor' や 'clue' など）と一致するリソースを設定する
      this.selectedPlugin = {
        type: pluginType,
        name: plugin.plugin_name,
        title: this.$t(`UserInfo.plugins.${pluginType}.title`),
        description: this.$t(`UserInfo.plugins.${pluginType}.explain`),
        price: this.$t(`UserInfo.plugins.${pluginType}.price`),
        image: this.getPluginImage(plugin)
      }
    },

    // プラグインのロゴ画像を取得する（ロゴは${plugin.plugin_type}_logo.svgから取得）
    getPluginImage(plugin) {
      try {
        return require(`@/assets/${plugin.plugin_type}_logo.svg`);
      } catch (error) {
        console.error(error)
        return '';
      }
    },

    showPluginDialog(plugin) {
      this.setSelectedPlugin(plugin);
      this.isShowEnabledPluginDialog = true;
    },

    enablePlugin() {
      this.isLoading = true
      PluginApi.enablePlugin(this.selectedPlugin.type).then(plugins => {
        this.$emit('update:plugins', plugins);
        this.$message.success(this.$t('user.success_plugin'));
      }).catch(error => {
        console.error(error);
        this.$message.error(this.$t('user.failed_plugin'));
      }).finally(() => {
        this.isLoading = false;
        this.isShowEnabledPluginDialog = false;
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.plugins {
  margin-top: 15px;
  .el-row {
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;

    .el-col.plugin {
      padding: 0 15px 0 0;
      text-align: center;
      width: 25%;

      &:last-child {
        padding-right: 0;
      }

      .inner {
        a {
          transition: all .3s ease-in-out;
          display: block;
          padding: 8px;
          border: 1px solid $border;
          border-radius: 6px;
          font-size: 13px;

          img {
            padding-top: 15px;
            padding-bottom: 5px;
            height: 40px;
            width: 100%;

            &.favor {
              height: 25px;
              padding-top: 25px;
              padding-bottom: 10px;
            }
            &.record {
              height: 30px;
              padding-top: 25px;
            }
            &.remotelock {
              height: 25px;
              padding-top: 30px;
            }
            &.clue {
              height: 30px;
              padding-top: 25px;
            }
          }

          &:hover {
            border:1px solid $safe;
            background: $select;

            img {
              filter: grayscale(0%);
            }
          }

          &.enabled {
            border:1px solid rgba(0,156,225,0.3);

            &:hover {
              border:1px solid $safe;
            }

            img {
              filter: grayscale(0%);
            }

            span {
              color: #FFF;
              &.title {
                background: $safe;
              }
            }
          }
          &.disabled {
            p.uncontract-label {
              margin: 7px 0 15px 0;
              span {
                color: #333;
                background: $border;
                border-radius: 20px;
                padding: 5px 10px;
              }
            }
          }

          img {
            transition: all .3s ease-in-out;
            filter:grayscale(100%);
            margin-bottom: 15px;
          }
          p.contract-label {
            display: inline-block;
            background: $safe;
            margin: 0 auto 15px auto;
            border: 1px solid $safe;
            border-radius: 20px;
            font-size: 12px;
          }
          span.title {
            display: inline-block;
            padding: 3px 15px 3px 15px;
            border-radius: 20px;
          }
        }
      }
    }
  }
}

.plugin-image {
  border: 1px solid #DDD;
  border-radius: 5px;
  padding: 50px;
  margin-bottom: 20px;
  text-align: center;
  img {
    height: 50px;
  }
}
p.plugin-price {
  display: inline-block;
  background: #DDD;
  border-radius: 30px;
  padding: 10px 20px;
  margin-top: 20px;
}
</style>
